import { Anchor } from 'components/atoms';
import Image from 'next/legacy/image';
import React from 'react';
import { useTranslation } from 'utils/hooks';

import css from './Adresse.module.scss';

type MapProps = {
  href: string;
};
const Map: React.FC<MapProps> = ({ href }) =>
{
  const { t } = useTranslation(['profiles']);

  return (
      <div className={css.mapContainer}>
        <Image src='/static/images/map.webp' alt='' width={900} height={300} />
        <div className={css.overlay}>
          <Anchor target="_blank" asVariant="secondary" as="button" href={href} >{t('profiles:actions.showMap')}</Anchor>
        </div>
      </div>
  );

};

export default Map;
